/**
 * models-authored:
 *
 * Keep just the models the logged in user authored.
 *
 *
 *
 */

(function ($, document) {
  $(document).on("bb:preHandleData", function (event, data) {
    if (data && data.models) {
      data.models = data.models.filter(function (m) {
        return m.yours;
      });
    }
  });
})(jQuery, document);
